import { setVideos,setAllContent,setFilteredContent, setPosts } from '../actions/index';

export const fetchPostsById = (tag,postId) => (dispatch,getState) => {
    var myHeaders = ({
      'Accept' : 'application/json',
      'Content-Type': 'application/json'
  });

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  return fetch(`https://recruitingmonk-v2.azurewebsites.net/posts/${tag}/${postId}`, requestOptions)
      .then(response => {
          if(response.ok) {
              console.log(response)
              return response;
          }
          else {
              var error = new Error("Error " + response.status + ": " + response.statusText);
              error.response = response;
              throw error;
          }
      }, 
      error => {
          var errmess = new Error(error.message);
          throw errmess;
      })
      .then(response => response.json())
      .then(data => {
          if(tag === 'video')
            dispatch(setVideos([data]))
          else 
            dispatch(setPosts([data]));
            
          dispatch(setAllContent([data]))
          dispatch(setFilteredContent([data]))
      })
      .catch(console.log);
}